import { api } from './api.ts';

export interface ScenarioInput {
  plan_id: number;
  name: string;
  return_adjustment: number;
  inflation_adjustment: number;
  retirement_age_adjustment?: number;
  notes?: string;
}

export interface AllocationProfileInput {
  risk_profile: string;
  asset_classes: string[];
  target_allocations: Record<string, number>;
  current_allocations: Record<string, number>;
  last_reviewed_date?: string;
}

export interface FinancialGoalInput {
  name: string;
  target_amount: number;
  target_date: string;
  priority: number;
  plan_id?: number;
}

export interface FIIndicatorInput {
  plan_id: number;
  annual_expenses: number;
  withdrawal_rate: number;
}

export const investmentAdvisoryApi = {
  createScenario: (payload: ScenarioInput) => api.post('/api/v1/investment-advisory/scenarios', payload),
  listScenarios: (planId: number) => api.get(`/api/v1/investment-advisory/scenarios?plan_id=${planId}`),
  compareScenarios: (planId: number) => api.get(`/api/v1/investment-advisory/scenarios/compare?plan_id=${planId}`),
  upsertAllocation: (payload: AllocationProfileInput) => api.post('/api/v1/investment-advisory/allocation', payload),
  createGoal: (payload: FinancialGoalInput) => api.post('/api/v1/investment-advisory/goals', payload),
  listGoals: () => api.get('/api/v1/investment-advisory/goals'),
  computeFIIndicators: (payload: FIIndicatorInput) => api.post('/api/v1/investment-advisory/fi-indicators', payload),
};
